module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_foodfly_m2.6502d317c42be972757adf2e4ccbf26b.png";